import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { MainPageLayout } from '#apps/client-web/app/components/main-page-layout';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { auditService } from '#apps/client-web/features/audit/services/audit';

import { AuditListPageContainer } from './audit-list-page.container';
import { useAuditListPageViewModel } from './audit-list-page.view-model';

export const AuditListPage = () => {
  const logger = useLogger('pages/audit-list');

  const viewModel = useAuditListPageViewModel({
    auditService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  return (
    <MainPageLayout title="Audit List">
      <AuditListPageContainer viewModel={viewModel} logger={logger} />
    </MainPageLayout>
  );
};
